import {
  View,
  ImageBackground,
  Image,
  StyleSheet,
  StyleProp,
  ViewStyle,
} from 'react-native';
import Text from '@/components/basic/text';
import React, {ReactNode} from 'react';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {downIcon} from '@/common-pages/rebate/rebate.variables';
import theme from '@/style';
import {toPriceStr} from '@/utils';
import {currentBrand} from '@/brands';
export interface ResultPanelProps {
  isWin?: boolean;
  winAmount?: number;
  onMore?: () => void;
  betInfo?: string | ReactNode;
  betTime?: string;
  children?: ReactNode | null;
  hideBorder?: boolean;
  hideBet?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
}

const ResultPanel = ({
  betInfo,
  onMore,
  winAmount,
  children,
  betTime,
  hideBorder,
  hideBet,
  containerStyle,
}: ResultPanelProps) => {
  const isAnna = currentBrand.key === 'anna';

  return (
    <View
      style={[
        theme.background.white,
        theme.borderRadius.m,
        theme.margin.l,
        theme.overflow.hidden,
        styles.container,
        containerStyle,
      ]}>
      {winAmount ? (
        <ImageBackground
          source={require('@components/assets/imgs/result/congratulations.webp')}>
          <View style={[theme.flex.center, styles.winWrap]}>
            <Text color={'#F15802'} size="medium" fontFamily="fontInterBold">
              Congratulations !
            </Text>
            <Text style={[styles.winDesc]}>You have won</Text>
            <Text main size="large" fontFamily="fontInterBold">
              {toPriceStr(winAmount)}
            </Text>
          </View>
        </ImageBackground>
      ) : (
        <View
          style={[
            theme.flex.center,
            styles.sorryWrap,
            styles.resultState,
            hideBorder && styles.resultStateNoBorder,
          ]}>
          <Text
            size="medium"
            fontFamily="fontInterBold"
            color={isAnna ? '#191919' : undefined}>
            Sorry!
          </Text>
          <Text
            accent
            style={[theme.margin.tops]}
            color={isAnna ? '#7F8896' : undefined}>
            Better Luck Next Time
          </Text>
        </View>
      )}
      {children}
      {!hideBet && (
        <View
          style={[
            theme.flex.row,
            theme.flex.between,
            theme.margin.lrl,
            theme.flex.centerByCol,
            styles.bottomContainer,
            isAnna && styles.annaBottomContainer,
          ]}>
          {betInfo ? (
            <View>
              <Text size="medium" fontFamily="fontInterBold" main>
                {betInfo}
              </Text>
            </View>
          ) : null}
          <View
            style={[
              theme.flex.flex1,
              theme.flex.row,
              Boolean(betInfo) && theme.flex.center,
            ]}>
            <View>
              <Text accent>Betting Time</Text>
              <Text style={[styles.betTimeText]}>{betTime}</Text>
            </View>
          </View>
          <NativeTouchableOpacity
            onPress={onMore}
            style={[
              theme.flex.row,
              theme.border.greyAccent,
              theme.padding.lrs,
              theme.flex.end,
              theme.borderRadius.xs,
              styles.moreButton,
              isAnna && styles.annaMoreButton,
            ]}>
            <Text style={isAnna ? styles.annaMoreText : undefined}>More</Text>
            <View style={[theme.margin.leftxxs, styles.moreIconWrap]}>
              <Image source={downIcon} style={[theme.icon.xs]} />
            </View>
          </NativeTouchableOpacity>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 0,
    paddingBottom: 0,
  },
  winWrap: {
    paddingVertical: 24,
    letterSpacing: -0.17,
  },
  winDesc: {
    fontWeight: '500',
    marginTop: 8,
    marginBottom: 4,
  },
  sorryWrap: {
    paddingVertical: 16,
    paddingHorizontal: 12,
    letterSpacing: -0.17,
  },
  resultState: {
    borderBottomColor: '#D8E0EA',
    borderBottomWidth: 1,
  },
  resultStateNoBorder: {
    borderBottomWidth: 0,
  },
  bottomContainer: {
    borderTopWidth: 1,
    borderTopColor: '#D8E0EA',
    marginTop: 8,
    paddingVertical: 8,
  },
  annaBottomContainer: {
    marginTop: 0,
  },
  betTimeText: {
    marginTop: 4,
  },
  moreButton: {
    minWidth: 68,
    paddingVertical: 4,
  },
  annaMoreButton: {
    minWidth: 0,
    height: 28,
    paddingHorizontal: 8,
    borderRadius: 4,
    alignItems: 'center',
  },
  annaMoreText: {
    color: '#7F8896',
    fontSize: 13,
    letterSpacing: -0.2,
  },
  moreIconWrap: {
    transform: [
      {
        rotate: '-90deg',
      },
    ],
  },
});

export default ResultPanel;
